import React from 'react';

export interface DetailHeaderProps {
  title: string;
  caseNumber?: string;
  isEditable?: boolean;
  saving?: boolean;
  onBack?: () => void;
 // onSave?: () => void;
  onPrint?: () => void;
}

export const DetailHeader: React.FC<DetailHeaderProps> = ({
  title,
  caseNumber,
 // isEditable = false,
 // saving = false,
  onBack,
  //onSave,
  onPrint,
}) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white border border-slate-200 hover:bg-slate-100 text-slate-700 font-medium text-xs shadow-sm transition"
          title="နောက်သို့ ပြန်သွားမည်"
        >
          <span>←</span>
          <span>နောက်သို့</span>
        </button>
        <div>
          <h1 className="text-xl font-bold text-slate-900">
            {title}
          </h1>
          <p className="text-xs text-slate-500 mt-0.5">
            အမှုအမှတ် - <strong className="text-slate-800">{caseNumber || '-'}</strong>
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        {/* {isEditable && (
          <button
            type="button"
            disabled={saving}
            onClick={onSave}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white rounded-lg text-xs font-semibold shadow-sm transition flex items-center gap-1.5 cursor-pointer disabled:cursor-not-allowed"
          >
            {saving ? (
              <>
                <span className="animate-spin h-3.5 w-3.5 border-2 border-white border-t-transparent rounded-full" />
                <span>သိမ်းဆည်းနေသည်...</span>
              </>
            ) : (
              <>
                <span>💾</span>
                <span>သိမ်းဆည်းမည်</span>
              </>
            )}
          </button>
        )} */}
        <button
          type="button"
          onClick={onPrint || (() => window.print())}
          className="px-4 py-2 bg-white border border-slate-200 rounded-lg text-xs font-semibold text-slate-700 hover:bg-slate-50 shadow-sm transition flex items-center gap-1.5"
        >
          <span>🖨️</span>
          <span>ပရင့်ထုတ်မည်</span>
        </button>
      </div>
    </div>
  );
};